// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { rankWith, uiTypeIs, or, isBooleanControl } from '@jsonforms/core';
import useClientId from 'common/hooks/useClientId';
import SwitchControl from './SwitchControl';

export const BannerControl = (props: any): React.Node => {
    const { t } = useTranslation('platform');

    const history = useHistory();
    const clientId = useClientId();

    const handleActionClick = () => {
        history.push(`/client/${clientId}/settings/trackIQ/banners`);
    };

    return (
        <SwitchControl
            {...props}
            action={{
                text: t(
                    // eslint-disable-next-line max-len
                    'settings.trackIQ.fields.liveViewSettings.fields.moduleSettings.fields.enableBannerModule.actionButtonLabel'
                ),
                onClick: handleActionClick
            }}
        />
    );
};

export default BannerControl;

export const bannerControlTester: any = rankWith(
    1,
    or(uiTypeIs('BannerControl'), isBooleanControl)
);
